import type { AiAgentConfiguration } from "./config/AiAgentConfiguration.js";

export interface GetAiAgentsResponse {
    aiAgents: AiAgentConfiguration[];
}
